import ContractsTable from "../../Components/ContractsTable/ContractsTable";

function ContractsView() {
  return (
    <>
      <ContractsTable />
    </>
  );
}

export default ContractsView;
